import { createClient, type SupabaseClient } from '@supabase/supabase-js';

let _client: SupabaseClient | null = null;

function getClient(): SupabaseClient {
  if (_client) return _client;
  const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
  const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;
  if (!url || !anon) {
    throw new Error(
      '[master-data] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY missing — add to monorepo root .env.local'
    );
  }
  _client = createClient(url, anon, {
    auth: { persistSession: true, autoRefreshToken: true },
  });
  return _client;
}

// Lazy proxy: module load is side-effect free. The env-var check + client
// construction only runs on first property access (which only happens when
// the user navigates into /master-data). Other admin-app pages import this
// transitively via App.tsx but never touch the client, so they don't throw.
export const supabase = new Proxy({} as SupabaseClient, {
  get(_, prop, receiver) {
    return Reflect.get(getClient(), prop, receiver);
  },
});

export async function callEdgeFunction<T = unknown>(name: string, body: unknown): Promise<T> {
  const { data, error } = await getClient().functions.invoke(name, {
    body: body as Record<string, unknown>,
  });
  if (error) throw new Error(`EF /${name}: ${error.message}`);
  return data as T;
}
